// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateConsultingRequestRequest,
  TCreateConsultingRequestModel,
  IMappers,
  TCreateConsultingRequestResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2CreateConsultingResponse } from '../../entities/consulting_request/V2CreateConsultingResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateConsultingRequestModel(
  parameters: TCreateConsultingRequestRequest,
): TCreateConsultingRequestModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-flat-view-order',
    pathApi: '/v2/create-consulting-request/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateConsultingRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateConsultingRequestRequest;
}

export async function fetchCreateConsultingRequest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateConsultingRequestOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateConsultingRequestResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateConsultingRequestModel(parameters),
    config,
  )) as FetchResponse<TCreateConsultingRequestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2CreateConsultingResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateConsultingRequestResponse>;
}
